var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"flex xs-right xs-12 bb1 bc7"},[_c('div',{staticClass:"cu2 c2 fw7 p4 bb2 bc2"},[_vm._v("\n\t\t\t"+_vm._s(_vm.$t("advanced_view"))+"\n\t\t")])]),_c('case-explorer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }